const CG_ZOOM_MAX_WIDTH = 2400,
  CG_EMBLA_BASE = {
    align: "center",
    containScroll: "trimSnaps",
    loop: !1,
    dragFree: !1,
    skipSnaps: !1,
    duration: 22,
  };
class CustomProductGallery extends HTMLElement {
  constructor() {
    (super(),
      (this.sectionId = this.dataset.sectionId),
      (this.isRTL = "true" === this.dataset.rtl),
      (this.dirSign = this.isRTL ? -1 : 1),
      (this.fixedRatio = this.dataset.fixedRatio || ""),
      (this.prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      ).matches),
      (this.currentIndex = 0),
      (this.isMobile = window.matchMedia("(max-width: 989px)").matches),
      (this.isFinePointer = window.matchMedia(
        "(hover: hover) and (pointer: fine)",
      ).matches));
    const t =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;
    this.isSlowConnection = !(
      !t ||
      !(
        t.saveData ||
        ["slow-2g", "2g", "3g"].includes(t.effectiveType) ||
        ("number" == typeof t.downlink && t.downlink > 0 && t.downlink < 2.5) ||
        ("number" == typeof t.rtt && t.rtt > 300)
      )
    );
    const e = navigator.hardwareConcurrency,
      i = navigator.deviceMemory;
    ((this.isLowEndDevice =
      ("number" == typeof i && i <= 2) || ("number" == typeof e && e <= 4)),
      (this.onThumbClick = this.onThumbClick.bind(this)),
      (this.onDotClick = this.onDotClick.bind(this)),
      (this.onPrevClick = this.onPrevClick.bind(this)),
      (this.onNextClick = this.onNextClick.bind(this)),
      (this.onVariantChange = this.onVariantChange.bind(this)),
      (this.onResize = this.onResize.bind(this)),
      (this.onEmblaSelect = this.onEmblaSelect.bind(this)),
      (this.onEmblaReInit = this.onEmblaReInit.bind(this)),
      (this.lightbox = null),
      (this.lightboxIndex = 0),
      (this.lightboxOpen = !1),
      (this.lightboxLastFocused = null),
      (this.emblaLightbox = null),
      (this.zoomScale = 1),
      (this.zoomPan = { x: 0, y: 0 }),
      (this.activePointers = new Map()),
      (this.pinchStartDistance = 0),
      (this.pinchStartScale = 1),
      (this.dragStart = null),
      (this.didPinchOrPan = !1),
      (this.pointerOrigin = null),
      (this.onPointerOrigin = this.onPointerOrigin.bind(this)),
      (this.onExpandClick = this.onExpandClick.bind(this)),
      (this.onShareClick = this.onShareClick.bind(this)),
      (this.onPhotoClick = this.onPhotoClick.bind(this)),
      (this.onImageKeydown = this.onImageKeydown.bind(this)),
      (this.onLightboxKeydown = this.onLightboxKeydown.bind(this)),
      (this.onLightboxPointerDown = this.onLightboxPointerDown.bind(this)),
      (this.onLightboxPointerMove = this.onLightboxPointerMove.bind(this)),
      (this.onLightboxPointerUp = this.onLightboxPointerUp.bind(this)),
      (this.onLightboxImageClick = this.onLightboxImageClick.bind(this)),
      (this.onLightboxSelect = this.onLightboxSelect.bind(this)));
  }
  cacheElements() {
    ((this.viewport = this.querySelector(".custom-gallery__main")),
      (this.track = this.querySelector(".custom-gallery__track")),
      (this.items = Array.from(this.querySelectorAll(".custom-gallery__item"))),
      (this.thumbs = Array.from(
        this.querySelectorAll(".custom-gallery__thumb"),
      )),
      (this.dotsContainer = this.querySelector(".custom-gallery__dots")),
      (this.dots = Array.from(this.querySelectorAll(".custom-gallery__dot"))),
      (this.counterCurrent = this.querySelector(
        ".custom-gallery__counter-current",
      )),
      (this.prevBtn = this.querySelector(".custom-gallery__nav--prev")),
      (this.nextBtn = this.querySelector(".custom-gallery__nav--next")),
      (this.thumbsRail = this.querySelector(".custom-gallery__thumbs")),
      (this.expandBtn = this.querySelector(".custom-gallery__expand")),
      (this.shareBtn = this.querySelector("[data-product-gallery-share]")),
      (this.shareStatus = this.querySelector("[data-gallery-share-status]")));
    const t = this.items.findIndex((t) => t.classList.contains("is-active"));
    this.currentIndex = t > -1 ? t : 0;
  }
  connectedCallback() {
    if ((this.cacheElements(), !this.track || 0 === this.items.length)) return;
    (this.isLowEndDevice && this.classList.add("custom-gallery--reduced-fx"),
      this.isRTL ||
        "rtl" !== getComputedStyle(this).direction ||
        ((this.isRTL = !0),
        (this.dirSign = -1),
        this.classList.add("custom-gallery--rtl")),
      (this.thumbHoverHandlers = []),
      this.thumbs.forEach((t) => {
        t.addEventListener("click", this.onThumbClick);
        const e = () => {
          const e = parseInt(t.dataset.index, 10);
          Number.isNaN(e) || this.loadImageAt(e);
        };
        (t.addEventListener("mouseenter", e),
          t.addEventListener("pointerdown", e, { passive: !0 }),
          this.thumbHoverHandlers.push({ thumb: t, onWarm: e }));
      }),
      this.prevBtn && this.prevBtn.addEventListener("click", this.onPrevClick),
      this.nextBtn && this.nextBtn.addEventListener("click", this.onNextClick),
      window.addEventListener("resize", this.onResize),
      this.track.addEventListener("click", this.onPhotoClick),
      this.track.addEventListener("keydown", this.onImageKeydown),
      this.updateImageControls(),
      this.viewport &&
        this.viewport.addEventListener("pointerdown", this.onPointerOrigin, {
          capture: !0,
          passive: !0,
        }),
      this.expandBtn &&
        this.expandBtn.addEventListener("click", this.onExpandClick),
      this.shareBtn &&
        this.shareBtn.addEventListener("click", this.onShareClick),
      this.dots.forEach((t) => {
        t.addEventListener("click", this.onDotClick);
      }),
      "function" == typeof subscribe &&
        "undefined" != typeof PUB_SUB_EVENTS &&
        (this.variantUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.onVariantChange,
        )),
      this.items.forEach((t) => {
        const e = t.querySelector("img:not([data-src])");
        e && (this.bindImageErrorRecovery(e), this.revealWhenDecoded(e));
      }),
      this.thumbs.forEach((t) => {
        const e = t.querySelector("img");
        e && this.bindImageErrorRecovery(e);
      }),
      this.initEmbla(),
      this.observeStickyGallery(),
      this.applyRtlColumnOrder(),
      this.updateAspectRatio(this.currentIndex),
      this.updateNavBoundaries(),
      this.revealActiveThumb(this.currentIndex, !1),
      this.revealActiveDot(this.currentIndex, !1));
    const t = () => {
        (this.preloadNeighbors(this.currentIndex), this.warmRemainingImages());
      },
      e = this.items[this.currentIndex]?.querySelector("img");
    e && !e.complete
      ? (e.addEventListener("load", t, { once: !0 }),
        e.addEventListener("error", t, { once: !0 }))
      : t();
  }
  enforceEmblaLayout() {
    this.track &&
      (Object.assign(this.track.style, {
        display: "flex",
        overflow: "visible",
        scrollSnapType: "none",
        gap: "0",
        width: "100%",
        maxWidth: "100%",
        touchAction: "pan-y",
        transition: "none",
        willChange: "transform",
      }),
      this.viewport && (this.viewport.style.touchAction = "pan-y"),
      this.items.forEach((t) => {
        Object.assign(t.style, {
          position: "relative",
          inset: "auto",
          flex: "0 0 100%",
          minWidth: "0",
          maxWidth: "100%",
          opacity: "1",
          visibility: "visible",
          transition: "none",
          scrollSnapAlign: "none",
        });
      }));
  }
  clearEmblaLayout() {
    this.track &&
      ([
        "display",
        "overflow",
        "scrollSnapType",
        "gap",
        "width",
        "maxWidth",
        "touchAction",
        "transition",
        "willChange",
      ].forEach((t) => {
        this.track.style[t] = "";
      }),
      this.viewport && (this.viewport.style.touchAction = ""),
      this.items.forEach((t) => {
        [
          "position",
          "inset",
          "flex",
          "minWidth",
          "maxWidth",
          "opacity",
          "visibility",
          "transition",
          "scrollSnapAlign",
        ].forEach((e) => {
          t.style[e] = "";
        });
      }));
  }
  applyRtlColumnOrder() {
    this.isRTL && (this.style.flexDirection = this.isMobile ? "" : "row");
  }
  observeStickyGallery() {
    const wrapper = this.closest(".product__media-wrapper--sticky");
    if (!wrapper || typeof ResizeObserver !== "function") return;
    this.stickyResizeObserver?.disconnect();
    this.stickyResizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      const height = entry.borderBoxSize?.[0]?.blockSize || this.getBoundingClientRect().height;
      this.style.setProperty("--gallery-sticky-height", Math.ceil(height) + "px");
    });
    this.stickyResizeObserver.observe(this);
  }
  initEmbla() {
    const t = window.EmblaCarousel;
    if ("function" != typeof t || !this.viewport || this.items.length < 1)
      this.emblaFailed = !0;
    else {
      this.enforceEmblaLayout();
      try {
        ((this.embla = t(this.viewport, {
          ...CG_EMBLA_BASE,
          container: this.track,
          slides: this.items,
          startIndex: this.currentIndex,
          direction: this.isRTL ? "rtl" : "ltr",
          duration: this.prefersReducedMotion ? 0 : CG_EMBLA_BASE.duration,
          watchDrag: (t, e) => {
            const i = e.target.closest && e.target.closest("[data-media-type]");
            return !i || "image" === i.getAttribute("data-media-type");
          },
        })),
          this.embla.on("select", this.onEmblaSelect),
          this.embla.on("reInit", this.onEmblaReInit),
          this.classList.add("custom-gallery--embla"));
        const e = this.embla.selectedScrollSnap();
        (e !== this.currentIndex
          ? this.syncToIndex(e)
          : this.updateNavBoundaries(),
          this.verifyEmblaGeometry());
      } catch (t) {
        (window.__CG_DEBUG &&
          console.error("[custom-gallery] Embla init failed:", t),
          this.clearEmblaLayout(),
          (this.emblaFailed = !0),
          (this.embla = null),
          this.classList.remove("custom-gallery--embla"));
      }
    }
  }
  verifyEmblaGeometry() {
    if (!this.embla || this.items.length < 2) return;
    const t = () => {
      if (!this.embla) return;
      const t = this.embla.scrollSnapList().length;
      t >= this.items.length ||
        (window.__CG_DEBUG &&
          console.warn(
            `[custom-gallery] نقاط التوقف ${t} أقل من عدد الصور ${this.items.length} — إعادة قياس. لو الرسالة دي فضلت تظهر، غالبًا الصور مش واقفة جنب بعض.`,
          ),
        this.enforceEmblaLayout(),
        this.embla.reInit());
    };
    requestAnimationFrame(() => requestAnimationFrame(t));
  }
  disconnectedCallback() {
    this.stickyResizeObserver?.disconnect();
    this.stickyResizeObserver = null;
    (window.removeEventListener("resize", this.onResize),
      this.resizeFrame && cancelAnimationFrame(this.resizeFrame),
      this.embla &&
        (this.embla.destroy(),
        (this.embla = null),
        this.clearEmblaLayout(),
        (this.style.flexDirection = "")),
      this.emblaLightbox &&
        (this.emblaLightbox.destroy(), (this.emblaLightbox = null)),
      this.track && this.track.removeEventListener("click", this.onPhotoClick),
      this.track && this.track.removeEventListener("keydown", this.onImageKeydown),
      this.viewport &&
        this.viewport.removeEventListener("pointerdown", this.onPointerOrigin, {
          capture: !0,
        }),
      this.expandBtn &&
        this.expandBtn.removeEventListener("click", this.onExpandClick),
      this.shareBtn &&
        this.shareBtn.removeEventListener("click", this.onShareClick),
      this.thumbs.forEach((t) =>
        t.removeEventListener("click", this.onThumbClick),
      ),
      this.dots.forEach((t) =>
        t.removeEventListener("click", this.onDotClick),
      ),
      (this.thumbHoverHandlers || []).forEach(({ thumb: t, onWarm: e }) => {
        (t.removeEventListener("mouseenter", e),
          t.removeEventListener("pointerdown", e));
      }),
      (this.thumbHoverHandlers = []),
      (this.railPaddingCache = null),
      "function" == typeof this.variantUnsubscriber &&
        this.variantUnsubscriber(),
      this.lightboxOpen && this.closeLightbox(),
      this.lightbox &&
        this.lightbox.parentNode &&
        this.lightbox.parentNode.removeChild(this.lightbox),
      (this.lightbox = null),
      (this.lightboxSlides = null));
  }
  onResize() {
    this.resizeFrame ||
      (this.resizeFrame = requestAnimationFrame(() => {
        ((this.resizeFrame = null), this.handleResize());
      }));
  }
  handleResize() {
    this.railPaddingCache = null;
    const t = this.isMobile;
    ((this.isMobile = window.matchMedia("(max-width: 989px)").matches),
      (this.isFinePointer = window.matchMedia(
        "(hover: hover) and (pointer: fine)",
      ).matches));
    this.updateImageControls();
    if (this.isMobile && this.dataset.enableFullscreenMobile === "false" && this.lightboxOpen) this.closeLightbox();
    const e = this.track ? this.track.clientWidth : 0,
      i = void 0 !== this.lastTrackWidth && this.lastTrackWidth !== e;
    ((this.lastTrackWidth = e),
      t !== this.isMobile && this.applyRtlColumnOrder(),
      (i || t !== this.isMobile) &&
        this.revealActiveThumb(this.currentIndex, !1));
  }
  updateImageControls() {
    const label = this.expandBtn?.getAttribute("aria-label") || "View fullscreen";
    this.items.forEach((item, index) => {
      const imageControl = item.querySelector(".custom-gallery__zoom");
      if (!imageControl) return;
      if (this.isMobile) {
        imageControl.removeAttribute("role");
        imageControl.removeAttribute("tabindex");
        imageControl.removeAttribute("aria-label");
      } else {
        imageControl.setAttribute("role", "button");
        imageControl.setAttribute("tabindex", index === this.currentIndex ? "0" : "-1");
        imageControl.setAttribute("aria-label", label);
      }
    });
  }
  onImageKeydown(event) {
    if (this.isMobile || !["Enter", " "].includes(event.key)) return;
    const imageControl = event.target.closest(".custom-gallery__zoom[role='button']");
    if (!imageControl || !this.track.contains(imageControl)) return;
    event.preventDefault();
    this.openLightbox(Number(imageControl.closest(".custom-gallery__item").dataset.index));
  }
  onPointerOrigin(t) {
    this.pointerOrigin = { x: t.clientX, y: t.clientY };
  }
  isRealClick(t) {
    return (
      !this.pointerOrigin ||
      (Math.abs(t.clientX - this.pointerOrigin.x) <= 6 &&
        Math.abs(t.clientY - this.pointerOrigin.y) <= 6)
    );
  }
  onThumbClick(t) {
    const e = parseInt(t.currentTarget.dataset.index, 10);
    Number.isNaN(e) || this.goTo(e);
  }
  onDotClick(t) {
    t.stopPropagation();
    const e = parseInt(t.currentTarget.dataset.index, 10);
    Number.isNaN(e) || this.goTo(e);
  }
  onPrevClick() {
    this.embla
      ? this.embla.scrollPrev()
      : this.currentIndex > 0 && this.goTo(this.currentIndex - 1);
  }
  onNextClick() {
    this.embla
      ? this.embla.scrollNext()
      : this.currentIndex < this.items.length - 1 &&
        this.goTo(this.currentIndex + 1);
  }
  onVariantChange(t) {
    if (!t || !t.data) return;
    if (t.data.sectionId && t.data.sectionId !== this.sectionId) return;
    const e = t.data.variant;
    if (!e || !e.featured_media) return;
    const i = this.items.findIndex(
      (t) => String(t.dataset.mediaId) === String(e.featured_media.id),
    );
    i > -1 && this.goTo(i, { instant: !0 });
  }
  goTo(t, { instant: e = !1 } = {}) {
    if (!(t < 0 || t >= this.items.length))
      return this.embla
        ? (this.embla.scrollTo(t, e || this.prefersReducedMotion),
          void (t === this.currentIndex && this.revealActiveThumb(t, !e)))
        : void this.syncToIndex(t);
  }
  selectIndex(t, e = {}) {
    this.goTo(t, { instant: !1 === e.smooth });
  }
  onEmblaSelect() {
    this.embla && this.syncToIndex(this.embla.selectedScrollSnap());
  }
  onEmblaReInit() {
    if (!this.embla) return;
    const t = this.embla.selectedScrollSnap();
    t !== this.currentIndex ? this.syncToIndex(t) : this.updateNavBoundaries();
  }
  syncToIndex(t) {
    if (t < 0 || t >= this.items.length) return;
    const e = this.currentIndex,
      i = e !== t;
    this.currentIndex = t;
    this.updateImageControls();
    if (i) {
      (this.items[e]?.classList.remove("is-active"),
        this.items[t]?.classList.add("is-active"));
      const i = this.thumbs[e];
      i &&
        (i.classList.remove("is-active"),
        i.setAttribute("aria-selected", "false"));
      const s = this.thumbs[t];
      (s &&
        (s.classList.add("is-active"), s.setAttribute("aria-selected", "true")),
        this.dots[e]?.classList.remove("is-active"),
        this.dots[t]?.classList.add("is-active"),
        this.counterCurrent && (this.counterCurrent.textContent = t + 1));
    }
    (this.loadImageAt(t, { priority: "high" }),
      this.preloadNeighbors(t),
      this.updateAspectRatio(t),
      this.updateNavBoundaries(),
      this.revealActiveThumb(t, !0),
      this.revealActiveDot(t, !0));
  }
  getRailPadding(t) {
    if (!this.railPaddingCache) {
      const e = getComputedStyle(t);
      this.railPaddingCache = {
        paddingTop: parseFloat(e.paddingTop) || 0,
        paddingBottom: parseFloat(e.paddingBottom) || 0,
        paddingLeft: parseFloat(e.paddingLeft) || 0,
        paddingRight: parseFloat(e.paddingRight) || 0,
      };
    }
    return this.railPaddingCache;
  }
  revealActiveThumb(t, e = !0) {
    const i = this.thumbsRail,
      s = this.thumbs[t];
    if (!i || !s || this.thumbs.length < 2) return;
    const o = i.scrollHeight > i.clientHeight + 1,
      n = i.scrollWidth > i.clientWidth + 1;
    if (!o && !n) return;
    const a = i.getBoundingClientRect(),
      r = this.getRailPadding(i),
      l = this.thumbs[0].getBoundingClientRect(),
      h = this.thumbs[1].getBoundingClientRect(),
      c = o ? Math.abs(h.top - l.top) : Math.abs(h.left - l.left);
    if (!c) return;
    const d = c - (o ? l.height : l.width),
      m = o
        ? i.clientHeight - r.paddingTop - r.paddingBottom
        : i.clientWidth - r.paddingLeft - r.paddingRight,
      g = Math.max(1, Math.round((m + d) / c)),
      u = Math.max(0, this.thumbs.length - g),
      b = Math.min(Math.max(t - 1, 0), u),
      x = this.thumbs[b].getBoundingClientRect();
    let p;
    if (
      ((p = o
        ? x.top - (a.top + r.paddingTop)
        : this.isRTL
          ? x.right - (a.right - r.paddingRight)
          : x.left - (a.left + r.paddingLeft)),
      Math.abs(p) < 1)
    )
      return;
    const y = e && !this.prefersReducedMotion ? "smooth" : "auto";
    if (o) {
      const t = i.scrollTop + p;
      "function" == typeof i.scrollTo
        ? i.scrollTo({ top: t, behavior: y })
        : (i.scrollTop = t);
    } else {
      const t = i.scrollLeft + p;
      "function" == typeof i.scrollTo
        ? i.scrollTo({ left: t, behavior: y })
        : (i.scrollLeft = t);
    }
  }
  revealActiveDot(t, e = !0) {
    const container = this.dotsContainer;
    const dot = this.dots[t];
    if (!container || !dot || this.dots.length < 2) return;
    if (container.scrollWidth <= container.clientWidth + 1) return;
    const behavior = e && !this.prefersReducedMotion ? "smooth" : "auto";
    const containerRect = container.getBoundingClientRect();
    const dotRect = dot.getBoundingClientRect();
    const offset = (dotRect.left + dotRect.width / 2) - (containerRect.left + containerRect.width / 2);
    if (Math.abs(offset) > 1) {
      if ("function" == typeof container.scrollBy) {
        container.scrollBy({ left: offset, behavior });
      } else {
        container.scrollLeft += offset;
      }
    }
  }
  updateAspectRatio(t) {
    if (this.fixedRatio) return;
    const e = this.items[t];
    if (!e || !this.track) return;
    const i = parseFloat(e.dataset.aspectRatio);
    i && !Number.isNaN(i) && this.viewport?.style.setProperty("--aspect-ratio", i);
  }
  updateNavBoundaries() {
    if (this.embla)
      return (
        this.prevBtn && (this.prevBtn.disabled = !this.embla.canScrollPrev()),
        void (
          this.nextBtn && (this.nextBtn.disabled = !this.embla.canScrollNext())
        )
      );
    (this.prevBtn && (this.prevBtn.disabled = this.currentIndex <= 0),
      this.nextBtn &&
        (this.nextBtn.disabled = this.currentIndex >= this.items.length - 1));
  }
  loadImageAt(t, { priority: e = "low" } = {}) {
    const item = this.items[t];
    const image = item?.querySelector("img");
    if (!image) return;
    // A user-selected image must not keep an earlier speculative lazy/low state.
    if (e === "high") {
      image.setAttribute("loading", "eager");
      image.setAttribute("fetchpriority", "high");
    }
    if (!image.dataset.src) return;
    this.bindImageErrorRecovery(image);
    if (image.dataset.sizes) {
      image.sizes = image.dataset.sizes;
      image.removeAttribute("data-sizes");
    }
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute("data-srcset");
    }
    image.src = image.dataset.src;
    image.removeAttribute("data-src");
    this.revealWhenDecoded(image);
  }
  revealWhenDecoded(t) {
    const e = () => {
        t.closest(".custom-gallery__zoom")?.classList.remove(
          "custom-gallery__zoom--placeholder",
        );
      },
      i = () => {
        t.classList.contains("custom-gallery__image--deferred")
          ? (t.classList.remove("custom-gallery__image--deferred"),
            t.classList.add("is-revealed"),
            t.addEventListener("animationend", e, { once: !0 }),
            window.setTimeout(e, 1e3))
          : e();
      };
    "function" == typeof t.decode
      ? t.decode().then(i).catch(i)
      : t.complete
        ? i()
        : (t.addEventListener("load", i, { once: !0 }),
          t.addEventListener("error", i, { once: !0 }));
  }
  bindImageErrorRecovery(t) {
    t &&
      !t.dataset.recoveryBound &&
      ((t.dataset.recoveryBound = "true"),
      t.addEventListener("error", () => {
        const e = Number(t.dataset.retryCount || 0);
        if (e >= 2)
          return (
            t.classList.remove(
              "custom-gallery__image--deferred",
              "custom-gallery-lightbox__image--loading",
            ),
            t
              .closest(".custom-gallery__zoom")
              ?.classList.remove("custom-gallery__zoom--placeholder"),
            void t.classList.add("custom-gallery__image--failed")
          );
        const i = t.currentSrc || t.src;
        i &&
          ((t.dataset.retryCount = String(e + 1)),
          window.setTimeout(
            () => {
              (t.removeAttribute("srcset"), t.removeAttribute("sizes"));
              try {
                const s = new URL(i, window.location.href);
                (1 === e && s.searchParams.set("_retry", Date.now()),
                  (t.src = s.toString()));
              } catch (e) {
                t.src = i;
              }
            },
            700 * (e + 1),
          ));
      }));
  }
  preloadNeighbors(t) {
    const e = this.items.length;
    e < 2 ||
      (t + 1 < e && this.loadImageAt(t + 1),
      !this.isSlowConnection && t - 1 >= 0 && this.loadImageAt(t - 1));
  }
  warmRemainingImages() {
    if (this.isSlowConnection || this.isMobile || document.hidden || !this.isConnected) return;
    const t = this.isLowEndDevice ? 5 : 12,
      e = window.requestIdleCallback || ((t) => setTimeout(t, 400));
    let i = 0,
      s = 0;
    const o = () => {
      if (!this.isConnected || document.hidden) return;
      for (
        ;
        i < this.items.length && !this.items[i].querySelector("img[data-src]");
      )
        i += 1;
      i >= this.items.length ||
        s >= t ||
        (this.loadImageAt(i), (i += 1), (s += 1), e(o));
    };
    e(o);
  }
  onExpandClick() {
    this.openLightbox(this.currentIndex);
  }
  async onShareClick() {
    if (!this.shareBtn) return;
    const t = window.location.href,
      e = this.shareBtn.dataset.shareTitle || document.title;
    if (navigator.share)
      try {
        return void (await navigator.share({ title: e, url: t }));
      } catch (t) {
        if ("AbortError" === t?.name) return;
      }
    try {
      navigator.clipboard && window.isSecureContext
        ? await navigator.clipboard.writeText(t)
        : this.copyShareUrlFallback(t),
        this.showShareSuccess();
    } catch (e) {
      try {
        (this.copyShareUrlFallback(t), this.showShareSuccess());
      } catch (t) {}
    }
  }
  copyShareUrlFallback(t) {
    const e = document.createElement("textarea");
    ((e.value = t),
      e.setAttribute("readonly", ""),
      Object.assign(e.style, {
        position: "fixed",
        opacity: "0",
        pointerEvents: "none",
      }),
      document.body.appendChild(e),
      e.select());
    const i = document.execCommand("copy");
    if ((e.remove(), !i)) throw new Error("Copy failed");
  }
  showShareSuccess() {
    if (!this.shareBtn) return;
    const t = this.shareBtn.dataset.shareSuccess || "";
    (this.shareStatus && (this.shareStatus.textContent = t),
      this.shareBtn.classList.add("is-copied"),
      this.shareFeedbackTimer && window.clearTimeout(this.shareFeedbackTimer),
      (this.shareFeedbackTimer = window.setTimeout(() => {
        (this.shareBtn?.classList.remove("is-copied"),
          this.shareStatus && (this.shareStatus.textContent = ""));
      }, 1800)));
  }
  onPhotoClick(t) {
    if (!this.expandBtn) return;
    if (!this.isRealClick(t)) return;
    if (!this.isFinePointer || this.isMobile) return;
    if (0 === t.detail) return;
    if (t.target.closest('a, button, [role="button"]:not(.custom-gallery__zoom), video, model-viewer'))
      return;
    const e = t.target.closest(".custom-gallery__zoom");
    if (!e) return;
    const i = e.closest(".custom-gallery__item");
    if (!i) return;
    const s = parseInt(i.dataset.index, 10);
    this.openLightbox(Number.isNaN(s) ? this.currentIndex : s);
  }
  getCloseIconMarkup() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  }
  getNavIconMarkup() {
    const t =
      this.nextBtn?.querySelector(".svg-wrapper")?.innerHTML ||
      this.prevBtn?.querySelector(".svg-wrapper")?.innerHTML;
    return (
      t ||
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>'
    );
  }
  buildLightbox() {
    if (this.lightbox) return;
    const t = this.items.length > 1,
      e = this.getNavIconMarkup(),
      i = document.createElement("div");
    ((i.className = "custom-gallery-lightbox"),
      i.setAttribute("dir", this.isRTL ? "rtl" : "ltr"),
      i.setAttribute("role", "dialog"),
      i.setAttribute("aria-modal", "true"),
      i.setAttribute(
        "aria-label",
        this.dataset.labelLightbox || "Product photos, fullscreen view",
      ),
      (i.innerHTML = `\n      <div class="custom-gallery-lightbox__header">\n        ${t ? '<div class="custom-gallery-lightbox__counter"><span data-role="current">1</span> / <span data-role="total"></span></div>' : ""}\n      </div>\n      <div class="custom-gallery-lightbox__stage"><div class="custom-gallery-lightbox__rail"></div></div>\n      <div class="custom-gallery-lightbox__toolbar">\n        ${t ? `<button type="button" class="custom-gallery-lightbox__nav custom-gallery-lightbox__nav--prev" aria-label="${this.dataset.labelPrev || "Previous"}"><span class="svg-wrapper">${e}</span></button>` : ""}\n        <button type="button" class="custom-gallery-lightbox__close" aria-label="${this.dataset.labelClose || "Close"}">${this.getCloseIconMarkup()}</button>\n        ${t ? `<button type="button" class="custom-gallery-lightbox__nav custom-gallery-lightbox__nav--next" aria-label="${this.dataset.labelNext || "Next"}"><span class="svg-wrapper">${e}</span></button>` : ""}\n      </div>\n    `));
    const s = i.querySelector(".custom-gallery-lightbox__stage"),
      o = i.querySelector(".custom-gallery-lightbox__rail");
    ((this.lightboxSlides = this.items.map((t, e) => {
      const i = document.createElement("div");
      ((i.className = "custom-gallery-lightbox__slide"),
        (i.dataset.index = String(e)));
      if ("image" === t.dataset.mediaType) {
        const e = document.createElement("img");
        ((e.className = "custom-gallery-lightbox__image"),
          (e.alt = t.querySelector("img")?.alt || ""),
          (e.draggable = !1));
        const s = this.getBaseImageUrl(t);
        (s && (e.src = s), this.bindImageErrorRecovery(e));
        const o = document.createElement("span");
        ((o.className = "custom-gallery-lightbox__spinner"),
          o.setAttribute("aria-hidden", "true"),
          i.appendChild(o),
          i.setAttribute("aria-busy", "true"));
        const n = () => {
          (i.classList.add("is-loaded"), i.removeAttribute("aria-busy"));
        };
        (e.complete && e.naturalWidth > 0
          ? n()
          : (e.addEventListener("load", n, { once: !0 }),
            e.addEventListener("error", n, { once: !0 })),
          i.appendChild(e));
      } else {
        const e = t.querySelector("video, model-viewer, iframe");
        if (e) {
          const t = e.cloneNode(!0);
          (t.classList.add("custom-gallery-lightbox__media-clone"),
            i.appendChild(t));
        }
      }
      return (o.appendChild(i), i);
    })),
      document.body.appendChild(i),
      (this.lightbox = i),
      (this.lightboxStage = s),
      (this.lightboxRail = o),
      (this.lightboxCounterCurrent = i.querySelector('[data-role="current"]')),
      (this.lightboxCounterTotal = i.querySelector('[data-role="total"]')),
      (this.lightboxPrevBtn = i.querySelector(
        ".custom-gallery-lightbox__nav--prev",
      )),
      (this.lightboxNextBtn = i.querySelector(
        ".custom-gallery-lightbox__nav--next",
      )),
      this.lightboxCounterTotal &&
        (this.lightboxCounterTotal.textContent = this.items.length),
      i
        .querySelector(".custom-gallery-lightbox__close")
        .addEventListener("click", () => this.closeLightbox()),
      this.lightboxPrevBtn?.addEventListener("click", () =>
        this.lightboxStep(-1),
      ),
      this.lightboxNextBtn?.addEventListener("click", () =>
        this.lightboxStep(1),
      ),
      i.addEventListener("click", (t) => {
        this.isRealClick(t) &&
          (this.didPinchOrPan ||
            (t.target !== i && t.target !== s) ||
            this.closeLightbox());
      }),
      s.addEventListener("pointerdown", this.onLightboxPointerDown, {
        capture: !0,
      }),
      s.addEventListener("pointermove", this.onLightboxPointerMove),
      s.addEventListener("pointerup", this.onLightboxPointerUp),
      s.addEventListener("pointercancel", this.onLightboxPointerUp),
      s.addEventListener("click", this.onLightboxImageClick),
      this.initLightboxEmbla());
  }
  enforceLightboxLayout() {
    this.lightboxStage &&
      this.lightboxRail &&
      (Object.assign(this.lightboxStage.style, {
        display: "block",
        position: "relative",
        overflow: "hidden",
        touchAction: "none",
      }),
      Object.assign(this.lightboxRail.style, {
        position: "relative",
        inset: "auto",
        display: "flex",
        width: "100%",
        height: "100%",
        transform: "",
        transition: "none",
        willChange: "transform",
        direction: "inherit",
        flexDirection: "row",
      }),
      this.lightboxSlides.forEach((t) => {
        Object.assign(t.style, {
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "0 0 100%",
          width: "100%",
          minWidth: "0",
          maxWidth: "100%",
          height: "100%",
        });
      }));
  }
  initLightboxEmbla() {
    const t = window.EmblaCarousel;
    if ("function" == typeof t && this.lightboxStage) {
      this.enforceLightboxLayout();
      try {
        ((this.emblaLightbox = t(this.lightboxStage, {
          ...CG_EMBLA_BASE,
          container: this.lightboxRail,
          slides: this.lightboxSlides,
          direction: this.isRTL ? "rtl" : "ltr",
          duration: this.prefersReducedMotion ? 0 : CG_EMBLA_BASE.duration,
          watchDrag: () =>
            this.zoomScale <= 1.02 && this.activePointers.size <= 1,
        })),
          this.emblaLightbox.on("select", this.onLightboxSelect));
      } catch (t) {
        this.emblaLightbox = null;
      }
    }
  }
  openLightbox(t) {
    if (this.isMobile && this.dataset.enableFullscreenMobile === "false") return;
    (this.buildLightbox(),
      (this.lightboxLastFocused = document.activeElement),
      (this.lightboxOpen = !0),
      this.lockBodyScroll(),
      this.lightbox.classList.add("is-open"),
      document.addEventListener("keydown", this.onLightboxKeydown),
      this.emblaLightbox && this.emblaLightbox.reInit(),
      this.lightboxSelectIndex(t, { instant: !0 }),
      this.lightbox.querySelector(".custom-gallery-lightbox__close").focus());
  }
  closeLightbox() {
    if (
      this.lightbox &&
      ((this.lightboxOpen = !1),
      this.lightbox.classList.remove("is-open"),
      this.unlockBodyScroll(),
      document.removeEventListener("keydown", this.onLightboxKeydown),
      this.activePointers.clear(),
      (this.dragStart = null),
      (this.didPinchOrPan = !1),
      (this.pinchStartDistance = 0),
      this.lightboxLastFocused &&
        "function" == typeof this.lightboxLastFocused.focus)
    )
      try {
        this.lightboxLastFocused.focus({ preventScroll: !0 });
      } catch (t) {
        this.lightboxLastFocused.focus();
      }
  }
  lockBodyScroll() {
    ((this.scrollLockY = window.scrollY || window.pageYOffset || 0),
      document.body.classList.add("custom-gallery-lightbox-open"),
      (document.body.style.position = "fixed"),
      (document.body.style.top = `-${this.scrollLockY}px`),
      (document.body.style.left = "0"),
      (document.body.style.right = "0"),
      (document.body.style.width = "100%"));
  }
  unlockBodyScroll() {
    (document.body.classList.remove("custom-gallery-lightbox-open"),
      (document.body.style.position = ""),
      (document.body.style.top = ""),
      (document.body.style.left = ""),
      (document.body.style.right = ""),
      (document.body.style.width = ""));
    try {
      window.scrollTo({
        top: this.scrollLockY || 0,
        left: 0,
        behavior: "instant",
      });
    } catch (t) {
      window.scrollTo(0, this.scrollLockY || 0);
    }
  }
  lightboxStep(t) {
    this.lightboxSelectIndex(this.lightboxIndex + t);
  }
  onLightboxSelect() {
    this.emblaLightbox &&
      this.syncLightboxToIndex(this.emblaLightbox.selectedScrollSnap());
  }
  lightboxSelectIndex(t, { instant: e = !1 } = {}) {
    if (!(!this.lightboxSlides || t < 0 || t >= this.lightboxSlides.length))
      return this.emblaLightbox
        ? (this.emblaLightbox.scrollTo(t, e || this.prefersReducedMotion),
          void (
            this.emblaLightbox.selectedScrollSnap() === t &&
            this.syncLightboxToIndex(t)
          ))
        : void this.syncLightboxToIndex(t);
  }
  syncLightboxToIndex(t) {
    !this.lightboxSlides ||
      t < 0 ||
      t >= this.lightboxSlides.length ||
      (this.resetZoom(),
      (this.lightboxIndex = t),
      this.lightboxSlides.forEach((e, i) =>
        e.classList.toggle("is-active", i === t),
      ),
      this.lightboxCounterCurrent &&
        (this.lightboxCounterCurrent.textContent = t + 1),
      this.lightboxPrevBtn &&
        (this.lightboxPrevBtn.disabled = this.emblaLightbox
          ? !this.emblaLightbox.canScrollPrev()
          : t <= 0),
      this.lightboxNextBtn &&
        (this.lightboxNextBtn.disabled = this.emblaLightbox
          ? !this.emblaLightbox.canScrollNext()
          : t >= this.items.length - 1),
      this.loadLightboxZoomAt(t),
      this.preloadLightboxNeighbors(t),
      this.currentIndex !== t && this.goTo(t, { instant: !0 }));
  }
  loadLightboxZoomAt(t) {
    const e = this.lightboxSlides[t],
      i = e?.querySelector(".custom-gallery-lightbox__image");
    if (!i || i.dataset.loaded) return;
    const s = this.getBaseImageUrl(this.items[t]);
    if (!s) return;
    i.dataset.loaded = "true";
    const o = this.getZoomUrl(s, 2400);
    i.classList.add("custom-gallery-lightbox__image--loading");
    const n = new Image();
    ((n.onload = () => {
      ((i.src = o), this.revealLightboxImage(i));
    }),
      (n.onerror = () => {
        i.classList.remove("custom-gallery-lightbox__image--loading");
      }),
      (n.src = o));
  }
  revealLightboxImage(t) {
    const e = () =>
      t.classList.remove("custom-gallery-lightbox__image--loading");
    "function" == typeof t.decode ? t.decode().then(e).catch(e) : e();
  }
  preloadLightboxNeighbors(t) {
    const e = this.lightboxSlides.length;
    e < 2 ||
      (t + 1 < e && this.loadLightboxZoomAt(t + 1),
      t - 1 >= 0 && this.loadLightboxZoomAt(t - 1));
  }
  getBaseImageUrl(t) {
    const e = t?.querySelector("img");
    return (e && (e.currentSrc || e.src || e.dataset.src)) || null;
  }
  getZoomUrl(t, e) {
    try {
      const i = new URL(t, window.location.href),
        s = Math.min(window.devicePixelRatio || 1, 3),
        o = window.innerWidth || 1024,
        n = Math.round(o * s),
        a = Math.min(e, Math.max(1200, n));
      return (
        i.searchParams.set("width", String(a)),
        i.searchParams.set("quality", "85"),
        i.toString()
      );
    } catch (e) {
      return t;
    }
  }
  onLightboxKeydown(t) {
    if ("Escape" === t.key)
      return (t.preventDefault(), void this.closeLightbox());
    if ("ArrowLeft" !== t.key)
      if ("ArrowRight" !== t.key) {
        if ("Tab" === t.key) {
          const e = this.lightbox.querySelectorAll(
            'button:not([disabled]), [href], [tabindex]:not([tabindex="-1"])',
          );
          if (0 === e.length) return;
          const i = e[0],
            s = e[e.length - 1];
          t.shiftKey && document.activeElement === i
            ? (t.preventDefault(), s.focus())
            : t.shiftKey ||
              document.activeElement !== s ||
              (t.preventDefault(), i.focus());
        }
      } else this.lightboxStep(1 * this.dirSign);
    else this.lightboxStep(-1 * this.dirSign);
  }
  onLightboxImageClick(t) {
    if (!this.isRealClick(t)) return;
    if (this.didPinchOrPan) return;
    const e = t.target.closest(".custom-gallery-lightbox__image");
    if (!e) return;
    if (this.zoomScale > 1) return void this.resetZoom();
    const i = e.getBoundingClientRect(),
      s = t.clientX - i.left - i.width / 2,
      o = t.clientY - i.top - i.height / 2;
    ((this.zoomScale = 2.2),
      (this.zoomPan = {
        x: -s * (this.zoomScale - 1),
        y: -o * (this.zoomScale - 1),
      }),
      this.clampZoomPan(e),
      this.applyZoomTransform(e),
      e.closest(".custom-gallery-lightbox__slide")?.classList.add("is-zoomed"));
  }
  onLightboxPointerDown(t) {
    if (
      (this.activePointers.set(t.pointerId, { x: t.clientX, y: t.clientY }),
      (this.pointerOrigin = { x: t.clientX, y: t.clientY }),
      (this.didPinchOrPan = !1),
      2 === this.activePointers.size)
    ) {
      const t = Array.from(this.activePointers.values());
      ((this.pinchStartDistance = Math.hypot(t[0].x - t[1].x, t[0].y - t[1].y)),
        (this.pinchStartScale = this.zoomScale));
    } else
      1 === this.activePointers.size &&
        this.zoomScale > 1 &&
        (this.dragStart = {
          x: t.clientX,
          y: t.clientY,
          panX: this.zoomPan.x,
          panY: this.zoomPan.y,
        });
  }
  onLightboxPointerMove(t) {
    if (!this.activePointers.has(t.pointerId)) return;
    this.activePointers.set(t.pointerId, { x: t.clientX, y: t.clientY });
    const e = this.lightboxSlides[this.lightboxIndex],
      i = e?.querySelector(".custom-gallery-lightbox__image");
    if (i)
      if (2 === this.activePointers.size) {
        const t = Array.from(this.activePointers.values()),
          s = Math.hypot(t[0].x - t[1].x, t[0].y - t[1].y);
        if (this.pinchStartDistance > 0) {
          this.didPinchOrPan = !0;
          const t = this.pinchStartScale * (s / this.pinchStartDistance);
          ((this.zoomScale = Math.min(4, Math.max(1, t))),
            this.clampZoomPan(i),
            this.applyZoomTransform(i),
            e.classList.toggle("is-zoomed", this.zoomScale > 1.02));
        }
      } else if (1 === this.activePointers.size && this.zoomScale > 1.02) {
        if (!this.dragStart)
          return void (this.dragStart = {
            x: t.clientX,
            y: t.clientY,
            panX: this.zoomPan.x,
            panY: this.zoomPan.y,
          });
        const e = t.clientX - this.dragStart.x,
          s = t.clientY - this.dragStart.y;
        ((Math.abs(e) > 3 || Math.abs(s) > 3) && (this.didPinchOrPan = !0),
          (this.zoomPan = {
            x: this.dragStart.panX + e,
            y: this.dragStart.panY + s,
          }),
          this.clampZoomPan(i),
          this.applyZoomTransform(i));
      }
  }
  onLightboxPointerUp(t) {
    const e = 2 === this.activePointers.size;
    (this.activePointers.delete(t.pointerId),
      0 === this.activePointers.size &&
        (this.zoomScale <= 1.02 &&
          this.lightboxSlides[this.lightboxIndex]?.classList.remove(
            "is-zoomed",
          ),
        e &&
          this.emblaLightbox &&
          this.emblaLightbox.scrollTo(this.lightboxIndex, !0),
        (this.dragStart = null),
        (this.pinchStartDistance = 0)));
  }
  clampZoomPan(t) {
    const e = this.lightboxStage.getBoundingClientRect(),
      i = Math.max(0, ((this.zoomScale - 1) * e.width) / 2),
      s = Math.max(0, ((this.zoomScale - 1) * e.height) / 2);
    ((this.zoomPan.x = Math.min(i, Math.max(-i, this.zoomPan.x))),
      (this.zoomPan.y = Math.min(s, Math.max(-s, this.zoomPan.y))));
  }
  applyZoomTransform(t) {
    t.style.transform = `translate(${this.zoomPan.x}px, ${this.zoomPan.y}px) scale(${this.zoomScale})`;
  }
  resetZoom() {
    ((this.zoomScale = 1), (this.zoomPan = { x: 0, y: 0 }));
    const t = this.lightboxSlides?.[this.lightboxIndex],
      e = t?.querySelector(".custom-gallery-lightbox__image");
    e && ((e.style.transform = ""), t.classList.remove("is-zoomed"));
  }
}
customElements.define("custom-product-gallery", CustomProductGallery);
